export enum Paths {
  Home = '/',
  Login = '/login',
  Auth = '/auth',
  Profile = '/profile',
  ChangePassword = '/change_pass',
  RestorePassword = '/restore_pass',
  Test = '/test',
  NotFound = '*',
}
